import * as React from "react";
const SvgCrossedCircle = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, fill: "none", viewBox: "0 0 18 18", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentcolor", d: "M13.773 13.773a6.75 6.75 0 0 0-9.546-9.546m9.546 9.546a6.75 6.75 0 0 1-9.546-9.546m9.546 9.546L4.227 4.227" }));
export default SvgCrossedCircle;
